import React, { useEffect, useState } from "react";
import { FaFacebook, FaYoutube, FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter, FaSquareInstagram, FaLinkedinIn } from "react-icons/fa6";
import { getFooterData } from "../Api/api";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [phone, setPhone] = useState("");
  const [socialLinks, setSocialLinks] = useState([]);
  const { t } = useTranslation();

  // 🟢 الخريطة لربط اسم الأيقونة بالـ Component
  const iconMap = {
    FaFacebook: <FaFacebook />,
    FaFacebookF: <FaFacebookF />,
    FaYoutube: <FaYoutube />,
    FaXTwitter: <FaXTwitter />,
    FaLinkedinIn: <FaLinkedinIn />,
    FaSquareInstagram: <FaSquareInstagram />,
    FaInstagram: <FaInstagram />,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getFooterData();
        setPhone(data.phone || "");
        setSocialLinks(data.social?.links?.filter((s) => !s.hidden) || []);
      } catch (err) {
        console.error("Failed to fetch footer data", err);
      }
    };
    fetchData();
  }, []);

  return (
    <footer className="shadow-lg rounded" style={{ backgroundColor: "#1b5773", color: "#fff" }}>
      <div className="container py-5">
        <div className="row text-center text-md-start">

          {/* Newsletter ثابت */}
          <div className="col-md-4 mb-4">
            <h4 className="mb-3">{t('footer.subscribe_newsletter')}</h4>
            <form className="d-flex flex-column flex-sm-row gap-2">
              <input type="email" placeholder={t('footer.email_placeholder')} required className="form-control" />
              <button type="submit" className="btn btn-success">{t('footer.submit')}</button>
            </form>
          </div>

          {/* Social Links */}
          <div className="col-md-4 mb-4 text-center">
            <h4 className="mb-3">{t('footer.stay_connected')}</h4>
            <div className="d-flex justify-content-center gap-4 fs-3">
              {socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#fff", transition: "all 0.3s ease-in-out" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = link.color)}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "#fff")}
                >
                  {iconMap[link.icon] || null}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Phone */}
          <div className="col-md-4 mb-4">
            <h4 className="mb-3">{t('footer.call_us')}</h4>
            <a
              href={`tel:${phone}`}
              className="btn d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              style={{ backgroundColor: "#16495f", color: "#fff" }}
            >
              <img
                src={require("../Images/listen.png")}
                alt="Call Us"
                style={{ width: "25px", height: "25px" }}
              />
              <span>{phone}</span>
            </a>
          </div>

        </div>
      </div>

      {/* Bottom Footer ثابت */}
      <div style={{ backgroundColor: "#16495f" }} className="py-3">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-center gap-2 text-center text-md-start">
          {/* <span>{t('footer.powered_by')}</span>
          <a href="https://staging.via-app.ca/" rel="home">
            <img src={require("../Images/logo-8 (1).png")} alt="Logo" style={{ width: "70px" }} />
          </a> */}
          <span>{t('footer.rights_reserved_2019')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
